/**
 * Shared plan copy for the 2026 Business tier launch. Several surfaces restate
 * these strings (pricing page, upsell modal, account area modals), so they live
 * here once — DEV-6406 / DEV-6389 / DEV-6390 all read from this module.
 */

/**
 * One-line description per plan, shown under the plan name on the upsell
 * cards. license only — the libraries are already spelled out by the icon
 * chips and tick list below it, so restating access here read as the card's
 * headline claim (DEV-6610 / DEV-6614 / DEV-6625).
 */
export const PLAN_DESCRIPTIONS = {
  Essentials: 'License for individuals.',
  Creator: 'License for individuals.',
  Pro: 'License for individuals, freelancers and solo professionals.',
  Business: 'License for teams, companies and organizations.',
} as const;

/** Short "who it's for" line per plan, shown under the plan name. */
export const PLAN_TAGLINES = {
  Essentials: 'For individual creators',
  Creator: 'For individual creators',
  Pro: 'For freelancers & power creators',
  Business: 'For organizations, brands & teams',
} as const;

/** License tooltip copy, as defined on the pricing page designs. */
export const LICENSE_TOOLTIPS = {
  proDigitalUse:
    'Social media, YouTube, websites, games, online ads. Does not cover paid streaming services.',
  businessDigitalUse:
    'Social media, YouTube, websites, games, online ads, internal comms. Does not cover paid streaming services.',
} as const;
